import Layout from '@/layout';

const superviseurRoutes = {
  path: '/espace-superviseur',
  component: Layout,
  redirect: '/espace-superviseur/dashboard',
  name: 'EspaceSuperviseur',
  meta: {
    title: 'espaceSuperviseur',
    icon: 'el-icon-s-check',
    permissions: ['superviser activites'],
    superviseurOnly: true,
  },
  children: [
    {
      path: 'dashboard',
      component: () => import(/* webpackChunkName: "superviseurDashboard" */ '@/views/superviseur/Dashboard'),
      name: 'SuperviseurDashboard',
      meta: {
        title: 'superviseurDashboard',
        icon: 'el-icon-data-board',
        permissions: ['superviser activites'],
        superviseurOnly: true,
      },
    },
    {
      path: 'a-valider',
      component: () => import(/* webpackChunkName: "superviseurAValider" */ '@/views/superviseur/AValider'),
      name: 'SuperviseurAValider',
      meta: {
        title: 'superviseurAValider',
        icon: 'el-icon-document-checked',
        permissions: ['superviser activites'],
        superviseurOnly: true,
      },
    },
    {
      path: 'equipe',
      component: () => import(/* webpackChunkName: "superviseurEquipe" */ '@/views/superviseur/Equipe'),
      name: 'SuperviseurEquipe',
      meta: {
        title: 'superviseurEquipe',
        icon: 'el-icon-s-custom',
        permissions: ['superviser activites'],
        superviseurOnly: true,
      },
    },
    {
      path: 'rapport',
      component: () => import(/* webpackChunkName: "superviseurRapport" */ '@/views/superviseur/Rapport'),
      name: 'SuperviseurRapport',
      meta: {
        title: 'superviseurRapport',
        icon: 'el-icon-s-data',
        permissions: ['superviser activites'],
        superviseurOnly: true,
      },
    },
    {
      path: 'profil',
      component: () => import(/* webpackChunkName: "superviseurProfil" */ '@/views/superviseur/ProfilSignature'),
      name: 'SuperviseurProfil',
      meta: {
        title: 'superviseurProfil',
        icon: 'el-icon-edit-outline',
        permissions: ['superviser activites'],
        superviseurOnly: true,
      },
    },
  ],
};

export default superviseurRoutes;
